import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const creditsRoutesDictionary = moduleRouteDictionaryFactory(
  'credits',
  'credits',
  {
    overview: 'overview',
    standardAssignmentFlow: 'standard-assignment-flow',
    importAssignmentFlow: 'import-assignment-flow',
    detail: 'detail/:id/:status',
  },
);
